import { TypedDocumentNode } from "@apollo/client";
import { useBasePerformMutation, UsePerformMutationOptions } from "@flaminem/utils";

import { useCreateError } from "src/errors";
import { ErrorCode } from "src/graphql/utils/errorBuilder.ts";

export const usePerformMutation = <TData, TVars>(
  mutation: TypedDocumentNode<TData, TVars>,
  options: UsePerformMutationOptions<TData, TVars, ErrorCode>
) => {
  const createError = useCreateError();
  return useBasePerformMutation<TData, TVars, ErrorCode>(mutation, options, createError);
};
